export const ITEM_TYPES_DND = {
  ROADMAP_COLUM_BOX: 'roadmapColumnBox',
};

export const getInputsMaxWidthPlusIcon = (inputsMaxWidth: number): number => {
  const iconWidth = 34;
  const spacingWidth = 8;

  const iconButtonWidth = iconWidth + spacingWidth;

  return inputsMaxWidth + iconButtonWidth * 2;
};
